import React from 'react';

export default function IdIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 6.5H5C3.89543 6.5 3 7.39543 3 8.5V17.5C3 18.6046 3.89543 19.5 5 19.5H19C20.1046 19.5 21 18.6046 21 17.5V8.5C21 7.39543 20.1046 6.5 19 6.5H14M10 6.5V5.5C10 4.39543 10.8954 3.5 12 3.5C13.1046 3.5 14 4.39543 14 5.5V6.5M10 6.5C10 7.60457 10.8954 8.5 12 8.5C13.1046 8.5 14 7.60457 14 6.5M9 14.5C10.1046 14.5 11 13.6046 11 12.5C11 11.3954 10.1046 10.5 9 10.5C7.89543 10.5 7 11.3954 7 12.5C7 13.6046 7.89543 14.5 9 14.5ZM9 14.5C10.3062 14.5 11.4174 15.3348 11.8292 16.5M9 14.5C7.69378 14.5 6.58249 15.3348 6.17065 16.5M15 11.5H18M15 15.5H17" stroke="#382152" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
